import { AvatarImage as Image } from 'src/shared/design-system/Avatar';
import { Star } from 'src/shared/design-system/Icon';
import { Clickable } from 'src/shared/design-system/Utilities';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';
import { FollowColors, FollowToggleIcon } from '../FollowToggleIcon';

export const imageWidth = 358;
export const imageHeight = 152;

export const CoverPhotoContainer = styled.div.attrs(() => ({
  'data-role': 'container',
}))`
  position: relative;
  height: ${imageHeight}px;
  width: ${imageWidth}px;
  transition: box-shadow ${Transition.Time.BASE};
`;

export const CoverPhotoImage = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
`;

export const AvatarImageContainer = styled.div`
  position: absolute;
  bottom: -24px;
  right: -4px;
`;

export const AvatarImageWrapper = styled.div`
  position: relative;
`;

export const AvatarImage = styled(Image).attrs(() => ({
  size: Spacing.QUADRUPLE,
}))<{ imgUrl?: string }>`
  border: 4px solid white;
`;

export const RatingContainer = styled.div`
  gap: calc(${Font.Size.XXS} / 2);
  font-size: ${Font.Size.S};
  ${Mixins.Flex.center()}
`;

export const RatingSeparator = styled.div.attrs(() => ({
  children: '·',
}))`
  font-size: ${Font.Size.XXL};
  line-height: ${Font.Size.S};
  margin: 0 0 0 calc(${Font.Size.XXS} / 2);
`;

export const RatingStar = styled(Star)`
  color: ${Colors.RADISH};
  max-width: ${Spacing.SINGLE};
  transform: translateY(-2px);
`;

export const FollowIcon = styled(FollowToggleIcon).attrs(() => ({
  followingColor: FollowColors.RED,
  isAnimated: false,
  isFollowing: true,
}))``;

export const FollowIconContainer = styled.div`
  align-items: center;
  background: ${Colors.WHITE};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  right: 0;
  height: calc(${Spacing.SINGLE_HALF} + ${Spacing.QUARTER});
  width: calc(${Spacing.SINGLE_HALF} + ${Spacing.QUARTER});
  position: absolute;

  & svg {
    margin-top: ${Spacing.QUARTER};
    width: ${Spacing.SINGLE};
  }
`;

export const Container = styled(Clickable).attrs(() => ({
  'data-role': 'shef-card',
}))`
  text-decoration: none;

  ${ifProp(
    'href',
    css`
      cursor: pointer !important;

      & button {
        cursor: pointer !important;
      }

      &:hover ${CoverPhotoContainer} {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
      }
    `
  )}
`;
